module.exports = {
    Add: require('./Add'),
  Amex: require('./Amex'),
  AndroidEN: require('./AndroidEN'),
  AndroidFR: require('./AndroidFR'),
  ArrowDownCircled: require('./ArrowDownCircled'),
  ArrowLeft: require('./ArrowLeft'),
  ArrowRight: require('./ArrowRight'),
  Bank: require('./Bank'),
  BankFilled: require('./BankFilled'),
  BoxOutline: require('./BoxOutline'),
  BoxOutlineChecked: require('./BoxOutlineChecked'),
  Bullet: require('./Bullet'),
  BulletCircle: require('./BulletCircle'),
  BulletFill: require('./BulletFill'),
  CanadaFilled: require('./CanadaFilled'),
  Cart: require('./Cart'),
  CartFilled: require('./CartFilled'),
  CartFilledMulti: require('./CartFilledMulti'),
  Caution: require('./Caution'),
  Check: require('./Check'),
  CheckCircle: require('./CheckCircle'),
  CheckCircleFilled: require('./CheckCircleFilled'),
  CheckCircledFilled: require('./CheckCircledFilled'),
  CheckCircledNotFilled: require('./CheckCircledNotFilled'),
  ChevronDown: require('./ChevronDown'),
  ChevronLeft: require('./ChevronLeft'),
  ChevronLeftCircle: require('./ChevronLeftCircle'),
  ChevronRight: require('./ChevronRight'),
  ChevronRightCircle: require('./ChevronRightCircle'),
  ChevronUp: require('./ChevronUp'),
  CircledLine: require('./CircledLine'),
  Clipboard: require('./Clipboard'),
  Close: require('./Close'),
  ClosedCaptions: require('./ClosedCaptions'),
  Coaxial: require('./Coaxial'),
  CreditCard: require('./CreditCard'),
  DSL: require('./DSL'),
  Devices: require('./Devices'),
  Download: require('./Download'),
  ExclamationOctagon: require('./ExclamationOctagon'),
  ExclamationTriangle: require('./ExclamationTriangle'),
  Expand: require('./Expand'),
  EyeClosed: require('./EyeClosed'),
  EyeMasked: require('./EyeMasked'),
  EyeOpened: require('./EyeOpened'),
  EyeUnmasked: require('./EyeUnmasked'),
  Fingerprint: require('./Fingerprint'),
  FullscreenExpand: require('./FullscreenExpand'),
  FullscreenMinimize: require('./FullscreenMinimize'),
  Gift: require('./Gift'),
  Hamburger: require('./Hamburger'),
  IOSEN: require('./IOSEN'),
  IOSFR: require('./IOSFR'),
  IdCard: require('./IdCard'),
  IdTag: require('./IdTag'),
  Info: require('./Info'),
  InfoSelected: require('./InfoSelected'),
  InformationCircled: require('./InformationCircled'),
  InternetSpeed: require('./InternetSpeed'),
  Kebab: require('./Kebab'),
  LeftCircle: require('./LeftCircle'),
  LinkExternal: require('./LinkExternal'),
  LocationMap: require('./LocationMap'),
  LocationMapFilled: require('./LocationMapFilled'),
  LockFilled: require('./LockFilled'),
  LockOpenFilled: require('./LockOpenFilled'),
  Maintenance: require('./Maintenance'),
  MaintenanceFilled: require('./MaintenanceFilled'),
  MasterCard: require('./MasterCard'),
  Muted: require('./Muted'),
  Number1FilledMono: require('./Number1FilledMono'),
  Number1FilledMulti: require('./Number1FilledMulti'),
  Number2FilledMono: require('./Number2FilledMono'),
  Number2FilledMulti: require('./Number2FilledMulti'),
  Number3FilledMono: require('./Number3FilledMono'),
  Number3FilledMulti: require('./Number3FilledMulti'),
  Number4FilledMono: require('./Number4FilledMono'),
  Number4FilledMulti: require('./Number4FilledMulti'),
  Number5FilledMono: require('./Number5FilledMono'),
  Number5FilledMulti: require('./Number5FilledMulti'),
  OfferStarFilled: require('./OfferStarFilled'),
  Pause: require('./Pause'),
  PaymentAdd: require('./PaymentAdd'),
  Perk: require('./Perk'),
  Phone: require('./Phone'),
  PhoneManage: require('./PhoneManage'),
  PhoneTroubleshoot: require('./PhoneTroubleshoot'),
  Play: require('./Play'),
  PlaySolid: require('./PlaySolid'),
  PlayVideo: require('./PlayVideo'),
  PlugPlay: require('./PlugPlay'),
  Preference: require('./Preference'),
  Price: require('./Price'),
  Profile: require('./Profile'),
  ProfileFilled: require('./ProfileFilled'),
  Question: require('./Question'),
  QuestionFilled: require('./QuestionFilled'),
  QuoteLeft: require('./QuoteLeft'),
  QuoteLeftArrow: require('./QuoteLeftArrow'),
  QuoteRightArrow: require('./QuoteRightArrow'),
  RadialOutline: require('./RadialOutline'),
  RadialOutlineChecked: require('./RadialOutlineChecked'),
  Receipt: require('./Receipt'),
  Refresh: require('./Refresh'),
  Replay: require('./Replay'),
  RightCircle: require('./RightCircle'),
  RightCirlce: require('./RightCirlce'),
  Settings: require('./Settings'),
  SettingsFilled: require('./SettingsFilled'),
  SettingsSolid: require('./SettingsSolid'),
  ShippingFilled: require('./ShippingFilled'),
  Shop: require('./Shop'),
  Sim: require('./Sim'),
  SimElectronic: require('./SimElectronic'),
  SimElectronicFilled: require('./SimElectronicFilled'),
  SimFilled: require('./SimFilled'),
  Spyglass: require('./Spyglass'),
  Streaming: require('./Streaming'),
  Subtract: require('./Subtract'),
  Tablet: require('./Tablet'),
  Tag: require('./Tag'),
  TagFilled: require('./TagFilled'),
  Times: require('./Times'),
  TimesCircled: require('./TimesCircled'),
  ToolTipFilled: require('./ToolTipFilled'),
  Tooltip: require('./Tooltip'),
  TooltipSymbol: require('./TooltipSymbol'),
  Unmuted: require('./Unmuted'),
  User: require('./User'),
  UserAdd: require('./UserAdd'),
  UserFilled: require('./UserFilled'),
  Visa: require('./Visa')
}